<template>
  <div class="box">
    <div v-if="$store.state.role === 'school-role'">
      <table-view
        :dataList="dataList"
        :columns="columns"
        :pagination="pagination"
        :loading="loading"
        :startTime="startTime"
        :endTime="endTime"
        :btnShow="btnShow"
        @deleteApply="deleteApply"
        @editInfo="editInfo"
        @getLxApplyApplylist="getLxApplyApplylist"
        @goQuery="goQuerySchool"
        titleType="educationalBrand"
      ></table-view>
    </div>
    <div v-if="$store.state.role === 'expert-role'">
      <expert-table-view
        :columns="expertColumns"
        :pagination="pagination"
        :timestampStartTime="timestampStartTime"
        :timestampEndTime="timestampEndTime"
        :reviewStartTimestamp="reviewStartTimestamp"
        :reviewEndTimestamp="reviewEndTimestamp"
        :reviewStartTime="reviewStartTime"
        :reviewEndTime="reviewEndTime"
        :data="expertData"
        :wokrName="'工作室'"
        :applyCount="applyCount"
        :schoolCount="schoolCount"
        @goQuery="goQuery"
        @updataInfo="updataInfo"
        @getApplyZjApplyList="getApplyZjApplyList"
        type="educationalBrand"
      ></expert-table-view>
    </div>
    <div v-if="$store.state.role === 'education-role'">
      <a-spin :spinning="spinning" tip="文件导出中,请稍等...">
        <education-table
          :dataList="dataList"
          :pagination="pagination"
          :loading="loading"
          :columns="educatioColumns"
          :wokrName="'工作室'"
          :applyCount="applyCount"
          :schoolCount="schoolCount"
          @editInfo="editInfo"
          @lxApplyExportZip="lxApplyExportZip"
          @getLxApplyjyjApplylist="getLxApplyjyjApplylist"
          type="educationalBrand"
        />
      </a-spin>
    </div>
  </div>
</template>

<script>
import {
  lxApplyApplylist,
  applyDateView,
  lxApplyApplyDelete,
  lxApplyjApplylist,
  expertDateView,
  lxApplyZjApplyList,
  lxApplyExportZip,
} from "@/api/index";
import tableView from "@/components/common/tableView.vue";
import expertTableView from "@/components/common/expertTableView.vue";
import { getTsFormatDate } from "@/utils/time";
import educationTable from "@/components/common/educationTable.vue";
export default {
  name: "",
  components: {
    tableView,
    expertTableView,
    educationTable,
  },
  props: {},
  data() {
    return {
      // 教育局
      educatioColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
          fixed: 'left' 
        },
        {
          title: "工作室名称",
          dataIndex: "name",
          id: "name",
          align: "center",
          scopedSlots: { customRender: "name" },
          width: 150,
        },
        {
          title: "学校",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
          width: 150,
        },
        {
          title: "主持人",
          dataIndex: "principals",
          id: "principals",
          align: "center",
          width: 90,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
          width: 100,
        },
        {
          title: "工作室实录视频",
          dataIndex: "duration",
          id: "duration",
          align: "center",
          scopedSlots: { customRender: "duration" },
          width: 150,
        },
        {
          // customTitle
          // title: "成员一实录视频",
          dataIndex: "duration1",
          id: "duration1",
          align: "center",
          slots: { title: 'duration1Title' },
          scopedSlots: { customRender: "duration1" },
          width: 100,
        },
        {
          // title: "成员二实录视频",
          dataIndex: "duration2",
          id: "duration2",
          align: "center",
          slots: { title: 'duration2Title' },
          scopedSlots: { customRender: "duration2" },
          width: 100,
        },
        {
          // title: "成员三实录视频",
          dataIndex: "duration3",
          id: "duration3",
          align: "center",
          slots: { title: 'duration3Title' },
          scopedSlots: { customRender: "duration3" },
          width: 100,
        },
        {
          title: "资料完整",
          dataIndex: "applyFilesFull",
          id: "applyFilesFull",
          align: "center",
          scopedSlots: { customRender: "applyFilesFull" },
          width: 100,
        },
        {
          title: "评审专家",
          dataIndex: "applyFiles",
          id: "applyFiles",
          align: "center",
          scopedSlots: { customRender: "applyFiles" },
          width: 100,
          fixed: 'right' 
        },
        {
          title: "评分",
          dataIndex: "score",
          id: "score",
          align: "center",
          scopedSlots: { customRender: "score" },
          width: 70,
          fixed: 'right' 
        },
        {
          title: "评审表",
          dataIndex: "examine",
          id: "examine",
          align: "center",
          scopedSlots: { customRender: "examine" },
          width: 85,
          fixed: 'right' 
        },
        {
          title: "均分",
          dataIndex: "avgscore",
          id: "avgscore",
          align: "center",
          scopedSlots: { customRender: "avgscore" },
          width: 70,
          fixed: 'right' 
        },
        // {
        //   title: "操作",
        //   id: "action",
        //   align: "center",
        //   scopedSlots: { customRender: "action" },
        // },
      ],
      // 学校
      columns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
        },
        {
          title: "工作室名称", // 特色文化育人品牌名称
          dataIndex: "name",
          id: "name",
          align: "center",
        },
        {
          title: "级别", 
          dataIndex: "levelType_dictText",
          id: "levelType_dictText",
          align: "center",
        },
        {
          title: "主持人", // 项目负责人
          dataIndex: "principals",
          id: "principals",
          align: "center",
          width: 150,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
          width: 150,
        },
        {
          title: "资料完整",
          dataIndex: "applyFilesFull",
          id: "applyFilesFull",
          align: "center",
          scopedSlots: { customRender: "applyFilesFull" },
          width: 100,
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 354,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 专家
      expertColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width: 70,
        },
        {
          title: "工作室名称",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 220,
        },
        {
          title: "学校",
          dataIndex: "realname",
          key: "realname",
          align: "center",
          width: 220,
        },
        {
          title: "主持人",
          dataIndex: "principals",
          key: "principals",
          align: "center",
          width: 120,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          key: "phone",
          align: "center",
          width: 120,
        },
        {
          title: "资料完整",
          dataIndex: "applyFilesFull",
          id: "applyFilesFull",
          align: "center",
          scopedSlots: { customRender: "applyFilesFull" },
          width: 100,
        },
        {
          title: "分数",
          dataIndex: "score",
          key: "score",
          align: "center",
          width: 80,
        },
        {
          title: "评审表",
          dataIndex: "scoreFile",
          key: "scoreFile",
          align: "center",
          scopedSlots: { customRender: "applyScoreFile" },
          width: 80,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      isShowView: false,
      startTime: "",
      endTime: "",
      dataList: [],
      loading: true,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20, //每页中显示10条数据
        showTotal: ((total) => {
          return `共 ${total} 条`;
        }),
      },
      timestampStartTime: "",
      timestampEndTime: "",
      btnShow: true,
      reviewStartTime: "",
      reviewEndTime: "",
      reviewStartTimestamp: "",
      reviewEndTimestamp: "",
      expertData: [],
      applyCount: 0,
      schoolCount: 0,
      spinning: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.$store.state.role === "school-role") {
      this.getLxApplyApplylist({
        page: 1,
        size: 20,
      });
      this.getapplyDateView();
    }
    if (this.$store.state.role === "education-role") {
      this.getLxApplyjyjApplylist({
        page: 1,
        size: 20,
      });
    }
    if (this.$store.state.role === "expert-role") {
      this.getApplyZjApplyList({
        page: 1,
        size: 20,
      });
      this.getexpertDateView();
    }
  },
  methods: {
    updataInfo() {
      this.getApplyZjApplyList({
        page: 1,
        size: 20,
      });
    },
    // 学校
    getLxApplyApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      lxApplyApplylist(data).then((res) => {
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    // 教育局
    getLxApplyjyjApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyjApplylist(data).then((res) => {
        if (res.code === 200) {
          let data = JSON.parse(JSON.stringify(res.result.pageList.records));
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.pageList.total;
            this.applyCount = res.result.applyCount;
            this.schoolCount = res.result.schoolCount;
          }
        }
        this.loading = false;
      });
    },
    // 获取专家列表
    getApplyZjApplyList(pagination) {
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.zpname != "") {
        data.zpname = pagination.zpname;
      }
      if (pagination.principals != "") {
        data.principals = pagination.principals;
      }
      if (pagination.Integrity != "") {
        data.applyFilesFull = pagination.Integrity;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyZjApplyList(data).then((res) => {
        if (res.code === 200) {
          this.expertData = res.result.pageList.records;
          this.applyCount = res.result.applyCount;
          this.schoolCount = res.result.schoolCount;
          this.pagination.total = res.result.pageList.total;
        }
      });
    },
    deleteApply(id) {
      lxApplyApplyDelete({ id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getLxApplyApplylist({
            page: 1,
            size: 20,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取申报时间
    getapplyDateView() {
      applyDateView().then((res) => {
        if (res.code == 200) {
          this.timestampStartTime = res.result.startTime;
          this.timestampEndTime = res.result.endTime;
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.startTime = getTsFormatDate(startTime);
          this.endTime = getTsFormatDate(endTime);
          var date1 = new Date();
          var timestamp = Date.parse(date1);
          if (timestamp < this.timestampStartTime) {
            this.btnShow = false;
          } else if (timestamp > this.timestampEndTime) {
            this.btnShow = false;
          } else if (
            timestamp > this.timestampStartTime &&
            timestamp < this.timestampEndTime
          ) {
            this.btnShow = true;
          }
        }
      });
    },
    goQuery(query) {
      const pagination = {
        page: 1,
        size: 20,
        name: query.name,
        principals: query.principals,
        schoolName: query.schoolName,
        Integrity: query.Integrity,
      };
      this.getApplyZjApplyList(pagination);
    },
    goQuerySchool(query) {
      const pagination = {
        page: 1,
        size: 20,
        name: query.name,
        principals: query.principals,
        Integrity: query.Integrity,
      };
      this.getLxApplyApplylist(pagination);
    },
    // 获取评审时间
    getexpertDateView() {
      expertDateView().then((res) => {
        if (res.code == 200) {
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.reviewStartTime = getTsFormatDate(startTime);
          this.reviewEndTime = getTsFormatDate(endTime);
          this.reviewStartTimestamp = res.result.startTime;
          this.reviewEndTimestamp = res.result.endTime;
        }
      });
    },
    editInfo(params, type) {
      params.type = type;
      console.log(params,'params')
      this.$router.push({ name: `${this.$route.name}DataUpload`, params });
    },
    lxApplyExportZip(data) {
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
       if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      lxApplyExportZip(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/zip" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else {
          fileName = "思政微课";
        }
        link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 19px 30px;
  min-height: 450px;
}
</style>
